export default "__VITE_ASSET__neHNOBTj__"